import { API_TEMPLATE } from '../libs/constant'
import { get } from '../libs/query'

const videoConfferenceApi = {
  getSessionRecordDetail (code) {
    const path = `${API_TEMPLATE.VIDEO_CONFERENCE_GET_RECORD_SESSION}?code=${code}`
    return get(path)
  }
}

export default videoConfferenceApi
